import { makeStyles } from '@policygenius/mortar';

const styles = makeStyles((theme) => ({
  submitButton: {
    display: 'block',
    margin: 'auto',
    maxWidth: 'calc(100% - 24px)',
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      maxWidth: '100%',
    },
  },
  securityNote: {
    marginTop: theme.spacing('small'),
    textAlign: 'center',
  },
}));

export default styles;
